import { createContext } from 'react'

const StepContext = createContext(null)

export default StepContext
